import { render, staticRenderFns } from "./BackupClientsTable.vue?vue&type=template&id=66c37a34&"
import script from "./BackupClientsTable.vue?vue&type=script&lang=js&"
export * from "./BackupClientsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports